import React from 'react'
import PropTypes from 'prop-types'

/** Composant graphique d'affichage d'un element comme dans le tableau de mendeleev */
export default class PeriodicElement extends React.Component {
    render() {
        return (
            <div className="periodic-element">
                <div className="periodic-number">{this.props.element.number}</div>
                <div className="periodic-symbol text-center">{this.props.element.symbol}</div>
                <div className="periodic-name text-center">{this.props.element.name}</div>
                <div className="periodic-atomic-mass text-center">{this.props.element.atomic_mass} g/mol</div>
            </div>
        )
    }
}

PeriodicElement.propTypes = {
    element: PropTypes.shape({
        number: PropTypes.number,
        name: PropTypes.string,
        symbol: PropTypes.string,
        atomic_mass: PropTypes.number
    })
}